import styled, { keyframes } from "styled-components";

// Definição da animação
const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
`;

// Estilização dos pontos
export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
//   font-size: 24px;
  font-weight: bold;
  color:${(p) => p.color??'#575757'};
`;

export const Dot = styled.span`
  animation: ${pulse} 1.5s infinite ease-in-out;
  animation-delay: ${(props) => props.delay || "0s"};
  margin: 0 4px;
  font-size: ${ (p) => p.size == "g"?"32px":"20px"};
  // color:#575757;
`;
